export const tokens = {
    error: {
        spacing: 10,
        marginTop: 32,
        titleSize: 16,
        messageSize: 14,
    },
    footer: {
        gap: 4,
    },
    createWalletLink: {
        padding: 6,
        fontSize: 14,
        radius: 4,
    },
};
